import app from 'flarum/common/app';
import Model from 'flarum/common/Model';

export default class Subscription extends Model {
  id() {
    return Model.attribute<string>('id').call(this);
  }

  amount() {
    return new Intl.NumberFormat('en-EN', {
      style: 'currency',
      currency: this.currency(),
    }).format(Model.attribute<number>('amount').call(this) / 100);
  }

  currency() {
    return Model.attribute<string>('currency').call(this);
  }

  active() {
    return !!Model.attribute<boolean>('active').call(this);
  }

  status() {
    return Model.attribute('status').call(this);
  }

  interval() {
    const interval = Model.attribute<string>('interval').call(this);
    const intervalCount = Model.attribute<number>('interval_count').call(this);

    if (!interval) return app.translator.trans('floxum-payments.forum.stripe.interval_once');

    return (intervalCount > 1 ? intervalCount + ' ' : '') + interval + (intervalCount > 1 ? 's' : '');
  }

  paymentType() {
    return Model.attribute<string>('paymentType').call(this);
  }

  cancellable() {
    return !!Model.attribute<boolean>('cancellable').call(this);
  }

  relatesTo<M extends Model>() {
    return Model.hasOne<M>('relatesTo').call(this);
  }

  apiEndpoint() {
    return '/blomstra-payments/stripe/user-subscriptions';
  }
}
